export default __webpack_public_path__ + "static/media/rakhi12.17888b9b.jpeg";